import React from 'react';
import { makeStyles } from '~/UIKit/Style';

//this component has no design yet
const useStyles = makeStyles(() => ({
  sideSectionRoot: {},
}));

export const ProviderSettingsSideSection = () => {
  const { classes } = useStyles();
  return <div className={classes.sideSectionRoot} />;
};
